import React, { useState } from 'react';
import './HelpCenter.css';

const faqs = [
  {
    question: 'What is the Learning and Development Portal?',
    answer: 'The Learning and Development Portal is an online platform designed to help users access courses, track progress, provide feedback, and manage their learning journey within the CriticalRiver organization.'
  },
  {
    question: 'How do I enroll in a course?',
    answer: 'Navigate to the Departments, browse available courses, and click on the enroll button for the course you wish to join.'
  },
  {
    question: 'How can I provide feedback on a course or the platform?',
    answer: 'Go to the Feedback page from the footer, fill out the feedback form, and submit your comments. Your feedback helps us improve the platform.'
  },
  {
    question: 'Where can I find my certificates?',
    answer: 'Certificates for completed courses are available in the Certificates section, accessible from the footer or your main menu.'
  },
  {
    question: 'How do I view my Profile',
    answer: 'Go to the Profile page from the footer or main menu, where you can view your personal information.'
  },
  {
    question: 'How is my feedback used?',
    answer: 'Feedback is reviewed by the platform administrators to improve course content, platform features, and user experience.'
  },
  {
    question: 'Who can I contact for technical support?',
    answer: 'You can contact the support team via email at BTG.Support@CriticalRiver.com.'
  },
  {
    question: 'How do I track my learning progress?',
    answer: 'Your progress is tracked automatically and can be viewed in the My Courses section, where you can see completed and ongoing courses.'
  },
{
    question: 'What should I do if the test link doesn\'t arrive in my email within 48 hours after requesting it?',
    answer: 'Ensure you check your spam, junk, or promotions folder in your email account, as the test link email might have been filtered there.If you still encounter the issue, please reach out to BTG support via email at BTG.Support@CriticalRiver.com for assistance.'
  }, 
   {
    question: "I have completed a learning path L&D course, but the credits are not reflected",
    answer: "To earn credits, you must complete the WECP test and obtain a certificate within the designated end date for each course."
  },
  {
    question: "I have received a certificate, but the credits have not been awarded",
    answer: "If you have obtained a certificate yet the credits are still not reflected, it is likely that the certificate was not issued prior to the course's end date. Should this not be the case and the issue persists, please contact BTG support for assistance.Please note that completing the test within the stipulated time will not earn you a certificate; you need to generate the certificate on the L&D platform before the end date."
  },
  {
    question: "I wish to include a new course under a department",
    answer: "Kindly send an email to BTG.Support@CriticalRiver.com if you would like to add a new course."
  }
];


const HelpCenter = () => {
  const [openIdx, setOpenIdx] = useState(null);

  const handleToggle = (idx) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <div className="help-center-container">
      <h2>Help Center & Frequently Asked Questions</h2>
      <div className="faq-contact-note" style={{marginBottom: '2rem', fontWeight: 'bold'}}>
        If your queries are not solved via the FAQs below, you can contact the support team via email at <a href="mailto:BTG.Support@CriticalRiver.com">BTG.Support@CriticalRiver.com</a>.
      </div>
      <div className="faq-list">
        {faqs.map((faq, idx) => (
          <div className="faq-item" key={`faq-${faq.question.slice(0, 20).replace(/[^a-zA-Z0-9]/g, '')}-${idx}`}>
            <div
              className="faq-question"
              style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              onClick={() => handleToggle(idx)}
              aria-expanded={openIdx === idx}
              role="button"
              onKeyPress={e => { if (e.key === 'Enter' || e.key === ' ') handleToggle(idx); }}
            >
              <span style={{ marginRight: 8 }}>{openIdx === idx ? '▼' : '▶'}</span>
              <strong>Q: {faq.question}</strong>
            </div>
            {openIdx === idx && (
              <div className="faq-answer">A: {faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpCenter;
